import { Radio as BaseRadio } from '@base-ui/react/radio'
import { twMerge } from 'tailwind-merge'
import { choiceControlClasses } from '../../../lib/choice-control'
import { RadioGroupIndicator } from './indicator'
import type { PartProps } from '../../../lib/part-props'

interface RadioGroupItemProps extends PartProps<BaseRadio.Root.Props> {
  className?: string
}

function RadioGroupItem({ className, children, ...props }: RadioGroupItemProps) {
  return (
    <BaseRadio.Root
      className={twMerge(choiceControlClasses, 'group flex items-center justify-center rounded-full', className)}
      {...props}
    >
      {children ?? <RadioGroupIndicator />}
    </BaseRadio.Root>
  )
}

export { RadioGroupItem }
